(function (upp, jquery) {
    'use strict';

    upp.service('storage', function () {
        var provider;

        /**
         * CookiesProvider provides a storage interface to store data using cookies
         * @constructor
         */
        function CookiesProvider() {
            /**
             * By default the lifetime of the cookie is the session web (standard browser behavior).
             * By default the path of the cookie is the path of the page where the cookie was created (standard browser behavior).
             * By default the domain of the cookie is the domain of page where the cookie was created (standard browser behavior).
             * By default the cookie allow transmission by unsecured protocol (http and https) (standard browser behavior).
             * @see https://github.com/carhartl/jquery-cookie
             */
            var cookie = jquery.cookie;
            cookie.remove = jquery.removeCookie;

            this.set = function (key, value) {
                cookie(key, value, {path: '/'});
            };

            this.remove = function (key) {
                cookie.remove(key, {path: '/'});
            };

            this.get = function (key) {
                return cookie(key);
            };

            this.removeAll = function () {
                var val = cookie();

                for (var key in val) {
                    if (val.hasOwnProperty(key)) {
                        cookie.remove(key);
                    }
                }
            }
        }

        /**
         * LocalStorageProvider provides a storage interface to store data using localStorage
         * @constructor
         */
        function LocalStorageProvider() {
            var childUppId = $UPP.IDCHILDUPP,
                _storage = localStorage;

            var _K = function (key) {
                return childUppId + '_' + key;
            };

            this.set = function (key, value) {
                _storage.setItem(_K(key), value);
            };

            this.remove = function (key) {
                _storage.removeItem(_K(key));
            };

            this.get = function (key) {
                return _storage.getItem(_K(key));
            };

            this.removeAll = function () {
                _storage.clear();
            };
        }

        var localStorageAvailable = false;
        if ('localStorage' in window) {
            try {
                localStorage.setItem('localStorage', 1);
                localStorage.getItem('localStorage');
                localStorageAvailable = true;
            } catch (ignored) {
            }
        }

        if (!localStorageAvailable) {
            provider = new CookiesProvider();
        } else {
            provider = new LocalStorageProvider();
        }

        /**
         * Store a value for the given key
         * @method set
         * @param key
         * @param value
         */
        var set = function (key, value) {
            if (value || typeof value === 'number') {
                provider.set(key, value);
            } else {
                provider.remove(key);
            }
        };

        /**
         * Retrieves a value for the given key
         * @method get
         * @param key
         * @returns {*}
         */
        var get = function (key) {
            return provider.get(key);
        };

        /**
         * Removes the value for the given key
         * @method remove
         * @param key
         */
        var remove = function (key) {
            provider.remove(key);
        };

        /**
         * Removes all stored keys
         * @method removeAll
         */
        var removeAll = function () {
            provider.removeAll();
        };

        return {
            set: set,
            get: get,
            remove: remove,
            removeAll: removeAll
        };
    });
})(upp, window.jQuery);


// WEBPACK FOOTER //
// ./src/app/common/services/storage-service.js